import { createGlobalStyle } from "styled-components"

export const GlobalOverflowHidden = createGlobalStyle`
  body {
    overflow: hidden;
  }
`
